export default __webpack_public_path__ + "static/dishroomReading-857931b10fa63718f1c6dae490c5a747.svg";